import { provide, inject } from 'vue'

const useProvideInject = key => {
	const provideValue = value => {
		provide(key, value)
	}
	const injectValue = defaultValue => {
		const value = inject(key, defaultValue)
		if (value == null) {
			throw new Error(`Value for key ${key} not found`)
		}
		return value
	}
	return { provideValue, injectValue }
}

export const useProvideInjectWrapper = useProvideInject('wrapper');
export const useProvideInjectZoom = useProvideInject('zoom');
export const useProvideInjectFormChangedStatuses = useProvideInject('formChangedStatuses');
